<template>
    <svg
        id="LogoSvg"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        x="0px"
        y="0px"
        viewBox="0 0 276 37.3"
        style="enable-background: new 0 0 276 37.3"
        xml:space="preserve"
        width="476"
        height="64"
        role="img"
        aria-label="Looking4 logo"
    >
        <path
            id="path4"
            class="st0"
            d="M34.4,33.7h-0.7c-1.4-0.2-8-1.8-13.6-3.2C7.9,27.3,7.9,27,7.9,26.4c0-0.8,0-1.3,25.3-1.5h0.2
c26.7,4.3,26.7,5.2,26.7,5.8V31l-0.2,0.3C58.4,32.3,38.9,33.7,34.4,33.7z"
        />
        <path
            id="path6"
            class="st1"
            d="M8.5,26.3c0,0.7,22.8,6.5,25.3,6.7c2.4,0.3,25.6-1.5,25.6-2.4s-26.3-5.2-26.3-5.2S8.5,25.6,8.5,26.3
z"
        />
        <path
            id="path8"
            class="st2"
            d="M34.5,33.3h-0.7c-1.3-0.2-8.1-1.8-13.6-3.2C8.3,27,8.3,26.6,8.3,26.3s0-0.9,24.9-1.1
c0.1,0,6.7,1.1,13.1,2.2c13.3,2.4,13.3,2.8,13.3,3.2c0,0.1,0,0.2-0.1,0.3C58.3,31.8,38.9,33.3,34.5,33.3L34.5,33.3z M9.1,26.4
c3.1,1.3,22.2,6.1,24.7,6.4s22.6-1.3,25.1-2.2c-2-0.9-16.3-3.4-25.8-4.9C24.5,25.7,11.7,26,9.1,26.4z"
        />
        <path
            id="path89"
            class="st3"
            d="M47.6,30.7c1,0,4.1-0.1,5-0.3c0.1-0.2,2.2-2,2.1-6.1c-0.2-3.9-4.7,4.4-4.7,4.4s-1.5,1.3-2.3,1.8
c-0.1,0.1-1.1-0.2-1.2-0.1C46.5,30.4,47,30.7,47.6,30.7L47.6,30.7z"
        />
        <path
            id="path91"
            class="st4"
            d="M48.3,18.8h1.9l1.7,1.3l2.6,4c0,0,0.5,3.2-2,6.1c-2.1,0.2-4.7,0.3-4.7,0.3L48.3,18.8L48.3,18.8z"
        />
        <ellipse id="ellipse93" class="st3" cx="47.3" cy="24.7" rx="3.2" ry="5.9" />
        <ellipse id="ellipse95" class="st4" cx="47.3" cy="24.7" rx="3.1" ry="5.7" />
        <ellipse id="ellipse97" class="st5" cx="47.3" cy="24.7" rx="1.8" ry="3.3" />
        <path id="path99" class="st6" d="M13.3,10c0,0-0.4,0.1-0.6,0.6s0.1,0.7,0.1,0.7L13.3,10z" />
        <path id="path101" class="st7" d="M13.3,10.1c0,0-0.4,0.1-0.6,0.5s0.1,0.7,0.1,0.7L13.3,10.1z" />
        <path
            id="path103"
            class="st8"
            d="M11.2,15.5h-1.1c0,0-0.2-0.1-0.2,0.2v3.1c0,0,0.8,0.9,2.1,0.9h0.4v-3
C12.4,16.7,11.2,15.5,11.2,15.5z"
        />
        <path
            id="path105"
            class="st3"
            d="M31.4,31.9c0,0,4.3-0.1,5.3-0.3c0.1-0.2,2.2-2,2.1-6.1c-0.2-3.9-4.7,4.4-4.7,4.4
S32.1,31.7,31.4,31.9L31.4,31.9z"
        />
        <path
            id="path107"
            class="st9"
            d="M14.1,20.4h0.4l6.3-3.9L18.1,15l-3.8,2.1L14.1,20.4L14.1,20.4z M27.6,25.1h0.6l6.1-4.7v-1.3
l-6.4,0.6C27.9,19.7,27.6,25.1,27.6,25.1z"
        />
        <path
            id="path109"
            class="st4"
            d="M32.2,20.1h2l1.8,1.3l2.6,4c0,0,0.5,3.2-2,6.1c-2.1,0.2-4.3,0.2-4.3,0.2L32.2,20.1z"
        />
        <path id="path111" class="st3" d="M32.3,20.3h1.9l-0.3-0.2h-1.6C32.3,20.1,32.3,20.3,32.3,20.3z" />
        <path
            id="path113"
            class="st10"
            d="M34,15.1c0,0-1.1,2.3,1.7,4.2c1.5,1.7,3.2,3.3,3.2,3.3L55,22.3l0.4-1.4v-1.8L34,15.1z"
        />
        <path
            id="path115"
            class="st3"
            d="M16.7,28c0,0,0.6,0.3,1,0.3c0.7,0,4.3-0.1,5.2-0.3c0.1-0.2,2.2-2,2.1-6.1
c-0.2-3.9-4.7,4.4-4.7,4.4s-1.4,1.4-2.2,1.7c0,0-0.4,0.1-0.5,0.2L16.7,28L16.7,28z"
        />
        <path
            id="path117"
            class="st4"
            d="M18.5,16.4h1.9l1.7,1.3l2.6,4c0,0,0.5,3.2-2,6.1C20.6,28,18,28.1,18,28.1L18.5,16.4L18.5,16.4z"
        />
        <path id="path119" class="st3" d="M18.4,16.6h1.9L20,16.4h-1.6V16.6z" />
        <path
            id="path121"
            class="st3"
            d="M17.7,16.4H20l0.1,0.1l-1.6,0.1c0,0,0.6,0.5,0.7,0.6S17.8,16.4,17.7,16.4L17.7,16.4z"
        />
        <ellipse id="ellipse123" class="st3" cx="17.6" cy="22.3" rx="3.2" ry="5.9" />
        <ellipse id="ellipse125" class="st4" cx="17.6" cy="22.3" rx="3.1" ry="5.7" />
        <ellipse id="ellipse127" class="st5" cx="17.6" cy="22.3" rx="1.8" ry="3.3" />
        <ellipse id="ellipse129" class="st11" cx="17.6" cy="22.3" rx="1.2" ry="2.3" />
        <path id="path131" class="st3" d="M30.7,20.3h2l1.2-0.2c0,0-0.8-0.2-2.1-0.1C31.4,20,30.7,20.3,30.7,20.3z" />
        <path
            id="path133"
            class="st12"
            d="M35.6,21.6c0,0-1.4-2.1-4.5-2.1c-3,0-3.5,5.7-3.5,5.7l-6.4-2c0,0,0.3-6.9-3-7.3
c-3.9-0.5-4.1,4.5-4.1,4.5L12.2,20v-3.1l-1.4-0.7l2.7-6.5c0,0,1.9-0.5,4-0.3c0.5-0.5,3.6-4.2,5.3-4.8c1.5-0.4,7.1-1.1,9.3-1.1
s8.4,0.5,9.9,2c1.5,1.4,4.3,6.6,4.3,6.6s8.8-0.5,10.4,1.5c0.4,1.4,0.8,2.3-0.1,5.8c-4.6,0.5-9.2,1-15.2,1.1c-0.9,0-3.6-0.5-5.2-1.5
C35.4,18.2,35.6,21.6,35.6,21.6L35.6,21.6z"
        />
        <path
            id="path135"
            class="st13"
            d="M17.7,10.3c0,0,2.1,1,3.2,1.1c0.2-0.5,0.8-3.2,1.9-5.9C20.9,6.8,19.2,8,17.7,10.3L17.7,10.3z"
        />
        <path
            id="path137"
            class="st14"
            d="M22.8,5.6c-1,2.6-1.6,5.3-1.9,5.8c-1.1-0.1-3.1-1.1-3.1-1.1C19.3,7.9,20.9,6.8,22.8,5.6 M23.2,5
l-0.6,0.4c-1.8,1.2-3.6,2.4-5.1,4.8l-0.1,0.2l0.2,0.1c0.1,0,2.1,1,3.2,1.1H21l0.1-0.1c0.1-0.2,0.2-0.6,0.4-1.2
c0.3-1.2,0.8-2.9,1.5-4.7C23,5.6,23.2,5,23.2,5z"
        />
        <path
            id="path139"
            class="st13"
            d="M24.5,5.4c0,0,3.2-0.3,5.5,0.9c1.1,1.1,3.3,6.1,3.3,6.1s-0.1,1.4-10.5-0.5
C22.9,10.6,24,6.5,24.5,5.4z"
        />
        <path
            id="path141"
            class="st14"
            d="M25.3,5.4c1.1,0,3.1,0.1,4.7,0.9c1.1,1.1,3.3,6.1,3.3,6.1s0,0.5-2.2,0.5c-1.5,0-4-0.2-8.3-1
c0.1-1.3,1.2-5.4,1.7-6.5L25.3,5.4 M25.3,5.1h-1l-0.1,0.1c-0.5,1.1-1.6,5.3-1.7,6.5v0.2h0.2c7.2,1.4,10.2,1,10.6,0.8
c0.5-0.2,0.2-0.5,0.2-0.5C33.4,12,31.3,7.1,30.1,6C28.5,5.3,26.4,5.1,25.3,5.1L25.3,5.1z"
        />
        <path
            id="path143"
            class="st13"
            d="M34.5,12.1l11-0.6l-3.3-5.1c0,0-0.7-1.2-2-1.2h-6.4c0,0-2.2,0-2,0.7
C31.9,6.6,33.7,10.7,34.5,12.1L34.5,12.1z"
        />
        <path
            id="path145"
            class="st14"
            d="M40.1,5.2c1.4,0,2,1.2,2,1.2l3.3,5.1l-11,0.6c-0.8-1.4-2.6-5.5-2.8-6.2c-0.2-0.7,2-0.7,2-0.7
L40.1,5.2 M40.1,5h-6.4c-0.3,0-1.8,0-2.2,0.5c-0.1,0.1-0.1,0.3-0.1,0.4c0.2,0.7,2,4.7,2.8,6.2l0.1,0.1h0.1l11-0.6h0.4l-0.2-0.3
l-3.3-5.1C42.3,6.2,41.5,5,40.1,5L40.1,5z"
        />
        <path
            id="path147"
            class="st9"
            d="M48.6,11.8c3.1,0,8.2,0.5,8.2,1.6s0.9,1.2-0.2,5.8c-1.7,0.3-11.7,1.3-15.7,1.1
c-2-0.3-6.9-1.4-7-5.3C34.4,11,40.4,11.8,48.6,11.8L48.6,11.8z"
        />
        <path
            id="path149"
            class="st8"
            d="M35.5,20.6c0,1.6,0.4,5.6,7.5,5.6s11.5-1.1,11.5-1.1s2.4-0.4,2.4-2.9C56.6,20,55,19.4,55,19.4
l-0.9,0.1c0,0,1.9,1.6-0.7,2.2c-2.1,0.4-10.2,0.8-10.2,0.8s-5.3,0.2-6.9-3.1c-0.3-0.4-0.9-0.8-0.9,0.2S35.5,20.6,35.5,20.6z"
        />
        <path
            id="path151"
            class="st12"
            d="M57,16.1c0,1-0.5,2.9-0.5,3.1c-1.5,0.2-9,1-13.5,1.1c-0.3-0.4-0.4-1-0.4-1.8s0.4-1.4,0.8-1.4
s3.3-0.1,3.3-2.2s-4.7-3-6.1-3.1c4.5,0.1,6.5-0.3,11.6,1.3c0.1,0.1,0.3,0.2,0.3,0.4s-1.2,1.8,0.6,2.7C53.8,16.5,55.3,17.1,57,16.1z"
        />
        <path id="path153" class="st15" d="M46.7,16.7l5.8-0.2v2.3l-5.8,0.3V16.7L46.7,16.7z" />
        <path id="path155" class="st16" d="M46.9,16.9l5.4-0.2v1.9l-5.4,0.3V16.9z" />
        <path
            id="path157"
            class="st17"
            d="M40.9,13.6c-0.5,0.5-0.6,1-0.6,1.3S40.1,16,42.2,17c0,0.3-0.3,0.6-0.3,1.5s0.3,1.8,0.3,1.8h-1.3
c0,0-7-0.8-7-5.2c0.1-0.7,0.3-1.6,1.2-2.2C35.1,12.9,40.9,12.7,40.9,13.6L40.9,13.6z"
        />
        <path
            id="path159"
            class="st6"
            d="M43.6,13.1c0.9,0,2.7,0.6,2.7,1.9s-1.6,1.8-2.8,1.8S41,15.9,41,14.9
C40.9,13.8,42.3,13.1,43.6,13.1z"
        />
        <path
            id="path161"
            class="st7"
            d="M43.6,13.3c1.1,0,2.4,0.7,2.4,1.7s-1.4,1.6-2.4,1.6s-2.5-0.7-2.5-1.7S42.1,13.3,43.6,13.3z"
        />
        <path
            id="path163"
            class="st18"
            d="M43,14.6c0.6,0,1.1,0.4,1.1,0.8s-0.4,0.7-1,0.7s-1.3-0.4-1.3-0.8S42.1,14.6,43,14.6z M43.6,14
c0,0.3,0.4,0.5,0.8,0.5s0.7-0.1,0.7-0.4s-0.3-0.4-0.8-0.4C43.7,13.7,43.6,14,43.6,14L43.6,14z"
        />
        <path
            id="path165"
            class="st6"
            d="M54.8,12.8c1.3,0,2.5,0.7,2.5,1.8s-1.1,1.7-2.4,1.7s-2.6-0.6-2.6-1.8C52.4,13.3,54,12.8,54.8,12.8
z"
        />
        <path
            id="path167"
            class="st7"
            d="M54.9,13c1.4,0,2.3,0.9,2.3,1.6s-0.8,1.5-2.2,1.5s-2.3-0.7-2.3-1.6C52.6,13.5,54.1,13,54.9,13z"
        />
        <path
            id="path169"
            class="st18"
            d="M55.5,13.3c0.8,0,0.8,0.5,0.8,0.5s0,0.3-0.6,0.3s-0.8-0.2-0.8-0.4S55.3,13.3,55.5,13.3L55.5,13.3
z M55.5,15c0,0.7-0.9,0.7-1,0.7s-1.2-0.2-1.2-0.8s0.6-0.8,1.1-0.8C54.8,14.1,55.5,14.3,55.5,15L55.5,15z"
        />
        <path
            id="path171"
            class="st19"
            d="M35.5,6.1c1.3,0,3,1.8,3,1.8s-0.3-1.3,1.1-1.3s2.6,1.5,2.6,2.4s-0.8,1.1-1.2,1.1S39.4,9.7,39,9
c0,0.3,0.1,1.6-1.4,1.6c-1.4,0-3.6-1.7-3.6-3.3C34.2,5.9,35.5,6.1,35.5,6.1z"
        />
        <path
            id="path173"
            class="st20"
            d="M36.1,6.9c1.2,0,2.8,1,2.8,2.4c0,0.7-0.5,1.1-1.2,1.1s-3.1-0.9-3.1-2.6
C34.6,6.8,36.1,6.9,36.1,6.9z"
        />
        <path
            id="path175"
            class="st20"
            d="M39.9,7.2c1,0,2.2,1,2.2,1.8s-0.7,0.9-1,0.9S38.9,9.6,38.9,8C38.8,7.3,39.4,7.2,39.9,7.2z"
        />
        <path
            id="path177"
            class="st21"
            d="M36.2,7.5c0.8,0,1,0.5,1,1s-0.4,0.9-0.9,0.9c-0.6,0-1.1-0.5-1.1-1S35.4,7.5,36.2,7.5z M40.1,7.4
c0.9,0,1.1,0.7,1.1,1s-0.2,1-1,1c-0.6,0-0.9-0.6-1-1S39.3,7.4,40.1,7.4z"
        />
        <path
            id="path179"
            class="st22"
            d="M36.5,7.8c0.3,0,0.3,0.2,0.3,0.3s-0.1,0.3-0.3,0.3s-0.3-0.2-0.3-0.3S36.2,7.8,36.5,7.8z
    M40.4,7.7c0.2,0,0.3,0.1,0.3,0.3c0,0.1,0,0.3-0.3,0.3c-0.2,0-0.3-0.1-0.3-0.3C40.1,7.8,40.2,7.7,40.4,7.7z"
        />
        <ellipse id="ellipse181" class="st3" cx="31.4" cy="26" rx="3.2" ry="5.9" />
        <ellipse id="ellipse183" class="st4" cx="31.4" cy="26" rx="3.1" ry="5.7" />
        <ellipse id="ellipse185" class="st5" cx="31.4" cy="26" rx="1.8" ry="3.3" />
        <ellipse id="ellipse187" class="st11" cx="31.4" cy="26" rx="1.2" ry="2.3" />
        <path id="path189" class="st17" d="M17.1,9.6c0,0-0.3,0.3-0.3,0.5c-0.2-0.1-1.4-0.5-1.4-0.5H17.1z" />
        <path
            id="path230"
            class="st23"
            d="M47.3,18.6v-1.3h0.4v1H48v0.3H47.3z M48.1,18.1v-0.9h0.4v0.9c0,0.1,0.2,0.1,0.2,0v-0.9h0.4v0.9
c0,0.2-0.2,0.4-0.5,0.4S48.1,18.3,48.1,18.1z M49.2,18.5v-1.3h0.4v0.5l0.2-0.5h0.4l-0.3,0.6l0.3,0.7h-0.4L49.6,18v0.5H49.2z
    M50.3,18.4v-1.3H51v0.3h-0.3v0.2h0.2v0.3h-0.2v0.2H51v0.3H50.3z M52.1,18v-0.2H52V17h-0.3l-0.5,0.8V18h0.5v0.3H52L52.1,18z
    M51.7,17.3v0.5h-0.3L51.7,17.3z"
        />
        <path
            class="st24"
            d="M175.7,28.4v4.7h-8.8v-4.7h-11v-5.2l10.6-18.4h9.2v18.8h1.9v4.8L175.7,28.4L175.7,28.4z M167.1,13.1
c0,0-0.6,1.9-1.9,4.2l-3.5,6.2h5.4v-6.1C166.9,15.1,167.2,13.1,167.1,13.1z M66.1,29.2V8.9h3.8v17.8h5.6v2.5
C75.5,29.2,66.1,29.2,66.1,29.2z"
        />
        <path
            class="st24"
            d="M81.7,29.5c-5.5,0-7.6-4.7-7.6-10.4s2.2-10.4,7.6-10.4c5.5,0,7.6,4.7,7.6,10.4C89.3,24.9,87.1,29.5,81.7,29.5z
    M81.7,11.1c-3.1,0-3.8,4-3.8,7.8s0.6,7.8,3.8,7.8s3.8-4,3.8-7.8C85.5,15.2,84.8,11.1,81.7,11.1z M97.4,29.5
c-5.5,0-7.6-4.7-7.6-10.4S92,8.7,97.4,8.7c5.5,0,7.6,4.7,7.6,10.4C105,24.9,102.8,29.5,97.4,29.5z M97.4,11.1c-3.1,0-3.8,4-3.8,7.8
s0.6,7.8,3.8,7.8s3.8-4,3.8-7.8C101.2,15.2,100.5,11.1,97.4,11.1z M115.7,29.2l-5.8-10.3h-0.1v10.3h-3.7V8.9h3.7v9.3h0.1l5.8-9.3
h3.8l-6.3,9.4l6.7,10.9L115.7,29.2L115.7,29.2z M119.9,29.2V8.9h3.8v20.3C123.7,29.2,119.9,29.2,119.9,29.2z M136.6,29.2l-7.7-13.1
c-0.7-1.1-1.2-2.3-1.2-2.3h-0.1c0,0,0.1,1.1,0.1,2.4v13h-3.2V8.9h3.5l7.3,12.3c0.7,1.1,1.1,2.1,1.1,2.1h0.1c0,0-0.1-1-0.1-2.2V8.9
h3.1v20.3L136.6,29.2L136.6,29.2z M148.9,29.5c-5.4,0-8.8-3.7-8.8-10.6c0-6.5,3.7-10.3,8.9-10.3c2.3,0,3.9,0.4,5.1,1.1L153,12
c-0.6-0.4-1.8-0.8-3.5-0.8c-3.5,0-5.6,2.4-5.6,7.8c0,5.1,2.1,7.8,4.9,7.8c1.1,0,1.7-0.2,2-0.4v-6.7h-2.9v-2.3h6.5v11
C153.1,29.1,151.6,29.5,148.9,29.5L148.9,29.5z M182.8,20.5l-1-0.1v8.8h-1.7V9.7c1-0.6,2.6-1.1,4.5-1.1c4.4,0,6.5,2.4,6.5,6
C191.1,18.1,188.7,21,182.8,20.5L182.8,20.5z M184.5,9.7c-1.3,0-2.2,0.3-2.7,0.5v9.1l1,0.1c4.9,0.4,6.7-1.7,6.7-4.9
C189.5,11.4,187.9,9.7,184.5,9.7L184.5,9.7z M203.8,29.2l-2.2-6.9h-7.4l-2.3,6.9h-1.6l7-20.3h1.3l7,20.3H203.8z M198.6,13
c-0.5-1.7-0.6-2.5-0.6-2.5h-0.1c0,0-0.1,0.8-0.7,2.4l-2.7,8.2h6.7L198.6,13L198.6,13z M216.9,29.2l-7.6-9.7h-0.1v9.7h-1.6V9.7
c0.8-0.5,2.5-1.1,4.5-1.1c4.2,0,6.4,2.2,6.4,5.9c0,3.8-2.6,5.9-6.9,5.7v0.1l7.3,8.9H216.9L216.9,29.2z M212,9.7
c-1.2,0-2.1,0.2-2.8,0.5v9c0.4,0.1,1.3,0.2,2.1,0.2c3.7,0,5.5-1.7,5.5-4.9C216.8,11.2,215.2,9.7,212,9.7L212,9.7z M230.3,29.2
l-7.4-10.7h-0.1v10.7h-1.6V8.9h1.6v9.5h0.1l7.3-9.5h1.8l-7.5,9.5l7.8,10.8H230.3L230.3,29.2z M234.2,29.2V8.9h1.7v20.3
C235.9,29.2,234.2,29.2,234.2,29.2z M251.8,29.2l-9.6-16.5c-0.8-1.4-1.4-2.7-1.4-2.7h-0.1c0,0,0.1,1.3,0.1,2.7v16.4h-1.4V8.8h2.2
l9.3,16.2c0.8,1.3,1.2,2.3,1.2,2.3h0.1c0,0-0.1-1-0.1-2.4V8.8h1.4v20.3h-1.7V29.2z M264.4,29.5c-4,0-8.2-3.1-8.2-10.6
c0-7.1,4.1-10.3,8.1-10.3c2.1,0,3.6,0.4,4.4,1l-0.5,1c-0.7-0.4-1.9-0.9-3.8-0.9c-4,0-6.5,3-6.5,9.4c0,5.9,2.9,9.2,6.5,9.2
c1.7,0,2.6-0.3,3.1-0.6v-8.5h-4v-1.1h5.6v10.3C268,29.1,266.8,29.5,264.4,29.5L264.4,29.5z"
        />
        <g>
            <path
                id="path89_1_"
                class="st25"
                d="M47.6,30.7c1.7,0,3.3-0.1,5-0.3c1.5-1.7,2.3-3.9,2.1-6.1c-0.2-3.9-4.7,4.4-4.7,4.4
    c-0.7,0.6-1.5,1.2-2.3,1.8c-0.1,0.1-1.1-0.2-1.2-0.1C46.8,30.6,47.2,30.7,47.6,30.7z"
            />
            <path
                id="path91_1_"
                class="st26"
                d="M48.3,18.8h1.9l1.7,1.3l2.6,4c0.2,2.2-0.5,4.4-2,6.1c-2.1,0.2-4.7,0.3-4.7,0.3L48.3,18.8z"
            />
            <ellipse id="ellipse93_1_" class="st25" cx="47.3" cy="24.7" rx="3.2" ry="5.9" />
            <ellipse id="ellipse95_1_" class="st26" cx="47.3" cy="24.7" rx="3.1" ry="5.7" />
            <ellipse id="ellipse97_1_" class="st27" cx="47.3" cy="24.7" rx="1.8" ry="3.3" />
            <path id="path99_1_" class="st28" d="M13.2,10c-0.3,0.1-0.5,0.3-0.6,0.6c-0.2,0.5,0.1,0.7,0.1,0.7L13.2,10z" />
            <path id="path101_1_" class="st29" d="M13.2,10c-0.3,0.1-0.5,0.3-0.6,0.5s-0.1,0.5,0.1,0.7L13.2,10z" />
            <path
                id="path103_1_"
                class="st30"
                d="M11.1,15.5H10c0,0-0.2-0.1-0.2,0.2v3.1c0.6,0.6,1.3,0.9,2.1,0.9h0.4v-3L11.1,15.5z"
            />
            <path
                id="path105_1_"
                class="st25"
                d="M31.4,31.9c0,0,4.3-0.1,5.3-0.3c1.5-1.7,2.3-3.9,2.1-6.1c-0.2-3.9-4.7,4.4-4.7,4.4
    C33.2,30.6,32.3,31.3,31.4,31.9z"
            />
            <path
                id="path107_1_"
                class="st31"
                d="M14,20.4h0.4l6.3-3.9L18.1,15l-3.8,2.1L14,20.4z M27.6,25.1h0.6l6.1-4.7v-1.3l-6.4,0.6
    L27.6,25.1z"
            />
            <path
                id="path109_1_"
                class="st26"
                d="M32.2,20.1h2l1.8,1.3l2.6,4c0.2,2.2-0.5,4.4-2,6.1c-2.1,0.2-4.3,0.2-4.3,0.2L32.2,20.1z"
            />
            <path id="path111_1_" class="st25" d="M32.2,20.3h1.9l-0.3-0.2h-1.6C32.2,20.1,32.2,20.3,32.2,20.3z" />
            <path
                id="path113_1_"
                class="st32"
                d="M34,15.1c0,0-1.1,2.3,1.7,4.2c1.5,1.7,3.2,3.3,3.2,3.3L55,22.3l0.4-1.4v-1.8L34,15.1z"
            />
            <path
                id="path115_1_"
                class="st25"
                d="M16.2,27.6c0.3,0.2,1,0.6,1.5,0.6c1.7,0,3.4,0,5.1-0.2c1.5-1.7,2.4-3.8,2.2-6
    c-0.2-3.9-4.7,4.4-4.7,4.4C19.6,27,18.8,27.5,18,28c-0.2,0-0.3-0.1-0.5,0L16.2,27.6z"
            />
            <path
                id="path117_1_"
                class="st26"
                d="M18.4,16.4h1.9l1.7,1.3l2.6,4c0.2,2.2-0.5,4.4-2,6.1c-2,0.2-4.6,0.3-4.6,0.3L18.4,16.4z"
            />
            <path id="path119_1_" class="st25" d="M18.3,16.6h1.9l-0.3-0.2h-1.6V16.6z" />
            <path
                id="path121_1_"
                class="st25"
                d="M17.7,16.4H20l0.1,0.1l-1.6,0.1c0,0,0.6,0.5,0.7,0.6C19.3,17.3,17.7,16.4,17.7,16.4z"
            />
            <ellipse id="ellipse123_1_" class="st25" cx="17.5" cy="22.2" rx="3.2" ry="5.9" />
            <ellipse id="ellipse125_1_" class="st26" cx="17.5" cy="22.2" rx="3.1" ry="5.7" />
            <ellipse id="ellipse127_1_" class="st27" cx="17.5" cy="22.2" rx="1.8" ry="3.3" />
            <ellipse id="ellipse129_1_" class="st33" cx="17.5" cy="22.2" rx="1.2" ry="2.3" />
            <path
                id="path131_1_"
                class="st25"
                d="M30.7,20.3h2l1.2-0.2c-0.7-0.1-1.4-0.2-2.1-0.1C31.4,20,31,20.1,30.7,20.3z"
            />
            <path
                id="path133_1_"
                class="st34"
                d="M35.5,21.6c-1.1-1.4-2.8-2.1-4.5-2.1c-3,0-3.4,5.6-3.4,5.6l-6.5-1.9c0,0,0.3-6.9-3-7.3
    c-3.9-0.5-4.1,4.5-4.1,4.5L12.1,20v-3.1l-1.4-0.7l2.7-6.5c1.3-0.3,2.6-0.4,4-0.3c0.5-0.5,3.6-4.2,5.3-4.8c3.1-0.6,6.2-1,9.3-1.1
    c2.2,0,8.4,0.5,9.9,2s4.3,6.6,4.3,6.6s8.8-0.5,10.4,1.5c0.4,1.4,0.8,2.3-0.1,5.8c-4.6,0.5-9.2,1-15.2,1.1c-1.8-0.1-3.6-0.6-5.2-1.5
    C35.3,18.2,35.5,21.6,35.5,21.6z"
            />
            <path
                id="path135_1_"
                class="st35"
                d="M17.7,10.2c1,0.5,2.1,0.9,3.2,1.1c0.2-0.5,0.8-3.2,1.9-5.9C20.7,6.7,19,8.3,17.7,10.2z"
            />
            <path
                id="path137_1_"
                class="st36"
                d="M22.7,5.5c-1,2.6-1.6,5.3-1.9,5.8c-1.1-0.2-2.1-0.6-3.1-1.1C19,8.3,20.7,6.7,22.7,5.5
        M23.1,5l-0.6,0.4c-2.1,1.2-3.8,2.8-5.1,4.8l-0.1,0.2l0.2,0.1c1,0.5,2.1,0.9,3.2,1.1h0.2l0.1-0.1c0.1-0.2,0.2-0.6,0.4-1.2
    c0.4-1.6,0.9-3.2,1.5-4.7L23.1,5z"
            />
            <path
                id="path139_1_"
                class="st35"
                d="M24.5,5.4c1.9-0.2,3.8,0.1,5.5,0.9c1.1,1.1,3.3,6.1,3.3,6.1s-0.1,1.4-10.5-0.5
    C23.1,9.6,23.7,7.4,24.5,5.4z"
            />
            <path
                id="path141_1_"
                class="st36"
                d="M25.3,5.4c1.6-0.1,3.2,0.2,4.7,0.9c1.1,1.1,3.3,6.1,3.3,6.1s0,0.5-2.2,0.5
    c-2.8-0.1-5.6-0.4-8.3-1c0.4-2.2,0.9-4.4,1.7-6.5L25.3,5.4 M25.3,5h-1l-0.1,0.1c-0.8,2.1-1.3,4.3-1.7,6.5v0.2h0.2
    c7.2,1.4,10.2,1,10.6,0.8s0.2-0.5,0.2-0.5c-0.1-0.2-2.2-5.1-3.4-6.2C28.5,5.4,26.9,5,25.3,5L25.3,5z"
            />
            <path
                id="path143_1_"
                class="st35"
                d="M34.4,12.1l11-0.6l-3.3-5.1c-0.4-0.7-1.2-1.1-2-1.2h-6.4c0,0-2.2,0-2,0.7
    C32.5,8,33.4,10.1,34.4,12.1z"
            />
            <path
                id="path145_1_"
                class="st36"
                d="M40.1,5.2c0.8,0,1.6,0.5,2,1.2l3.3,5.1l-11,0.6c-1.1-2-2-4.1-2.8-6.2c-0.2-0.7,2-0.7,2-0.7
    L40.1,5.2 M40.1,5h-6.4c-0.3,0-1.8,0-2.2,0.5c-0.1,0.1-0.1,0.3-0.1,0.4c0.2,0.7,2,4.7,2.8,6.2l0.1,0.1h0.1l11-0.6h0.4l-0.2-0.3
    l-3.3-5.1C41.7,5.4,40.9,5,40.1,5z"
            />
            <path
                id="path147_1_"
                class="st31"
                d="M48.6,11.8c3.1,0,8.2,0.5,8.2,1.6s0.9,1.2-0.2,5.8c-5.2,0.7-10.4,1.1-15.7,1.1
    c-2-0.3-6.9-1.4-7-5.3C34.4,11,40.4,11.8,48.6,11.8z"
            />
            <path
                id="path149_1_"
                class="st30"
                d="M35.5,20.6c0,1.6,0.4,5.6,7.5,5.6c3.9,0.1,7.7-0.3,11.5-1.1c1.4-0.3,2.4-1.5,2.4-2.9
    c-0.1-1.2-0.8-2.3-1.9-2.8l-0.9,0.1c0,0,1.9,1.6-0.7,2.2c-2.1,0.4-10.2,0.8-10.2,0.8s-5.3,0.2-6.9-3.1c-0.3-0.4-0.9-0.8-0.9,0.2
    C35.4,20.5,35.5,20.6,35.5,20.6z"
            />
            <path
                id="path151_1_"
                class="st37"
                d="M57,16c-0.1,1-0.3,2.1-0.5,3.1c-1.5,0.2-9,1-13.5,1.1c-0.3-0.5-0.5-1.2-0.4-1.8
    c0-0.8,0.4-1.4,0.8-1.4c0.4,0,3.3-0.1,3.3-2.2s-4.7-3-6.1-3.1c4.5,0.1,6.5-0.3,11.6,1.3c0.1,0.1,0.3,0.2,0.3,0.4s-1.2,1.8,0.6,2.7
    C54.3,16.8,55.8,16.7,57,16z"
            />
            <path id="path153_1_" class="st38" d="M46.6,16.6l5.8-0.2v2.3L46.6,19V16.6z" />
            <path id="path155_1_" class="st39" d="M46.9,16.9l5.4-0.2v1.9l-5.4,0.3V16.9z" />
            <path
                id="path157_1_"
                class="st40"
                d="M40.8,13.5c-0.4,0.3-0.6,0.8-0.6,1.3c0,0.3-0.2,1.1,1.9,2.1c-0.2,0.5-0.3,1-0.3,1.5
    c0,0.6,0.1,1.2,0.3,1.8h-1.3c0,0-7-0.8-7-5.2c0-0.9,0.5-1.7,1.2-2.2C35.1,12.8,40.8,12.7,40.8,13.5z"
            />
            <path
                id="path159_1_"
                class="st28"
                d="M43.5,13.1c0.9,0,2.7,0.6,2.7,1.9s-1.6,1.8-2.8,1.8s-2.5-0.9-2.5-1.9S42.3,13.1,43.5,13.1z"
            />
            <path
                id="path161_1_"
                class="st29"
                d="M43.5,13.3c1.1,0,2.4,0.7,2.4,1.7s-1.4,1.6-2.4,1.6S41,15.9,41,14.9S42.1,13.3,43.5,13.3z"
            />
            <path
                id="path163_1_"
                class="st41"
                d="M42.9,14.6c0.6,0,1.1,0.4,1.1,0.8c0,0.4-0.4,0.7-1,0.7s-1.3-0.4-1.3-0.8S42.1,14.6,42.9,14.6
    z M43.5,14c0,0.3,0.4,0.5,0.8,0.5c0.4,0,0.7-0.1,0.7-0.4c0-0.3-0.3-0.4-0.8-0.4C44,13.6,43.7,13.7,43.5,14z"
            />
            <path
                id="path165_1_"
                class="st28"
                d="M54.8,12.7c1.3,0,2.5,0.7,2.5,1.8s-1.1,1.7-2.4,1.7s-2.6-0.6-2.6-1.8S54,12.7,54.8,12.7z"
            />
            <path
                id="path167_1_"
                class="st29"
                d="M54.9,12.9c1.4,0,2.3,0.9,2.3,1.6c0,0.7-0.8,1.5-2.2,1.5s-2.3-0.7-2.3-1.6
    C52.7,13.6,54.1,12.9,54.9,12.9z"
            />
            <path
                id="path169_1_"
                class="st41"
                d="M55.5,13.3c0.8,0,0.8,0.5,0.8,0.5s0,0.3-0.6,0.3s-0.8-0.2-0.8-0.4S55.3,13.3,55.5,13.3z
        M55.5,15c0,0.7-0.9,0.7-1,0.7s-1.2-0.2-1.2-0.8s0.6-0.8,1.1-0.8S55.5,14.3,55.5,15L55.5,15z"
            />
            <path
                id="path171_1_"
                class="st42"
                d="M34.8,5.3c1.9,0,4.3,2.6,4.3,2.6c-0.3-0.8,0.2-1.6,0.9-1.8l0,0c0.2-0.1,0.4-0.1,0.7,0
    c1.9,0.2,3.4,1.6,3.7,3.5c0,0.9-0.7,1.6-1.6,1.6h-0.2c-1.1-0.1-2.2-0.7-2.9-1.6c0.2,1-0.4,2-1.4,2.3c-0.2,0-0.4,0-0.5,0
    c-2,0-5.2-2.4-5.2-4.7c0.1-1,0.9-1.8,1.9-1.7l0,0L34.8,5.3L34.8,5.3z"
            />
            <path
                id="path173_1_"
                class="st43"
                d="M35.7,6.4c1.7,0,4,1.4,4,3.5c0,0.8-0.6,1.5-1.4,1.6H38c-1,0-4.4-1.3-4.4-3.7
    C33.5,6.3,35.7,6.4,35.7,6.4z"
            />
            <path
                id="path175_1_"
                class="st43"
                d="M41.1,6.9c1.4,0,3.2,1.4,3.2,2.6c0,0.7-0.6,1.3-1.3,1.3h-0.2c-0.4,0-3.2-0.4-3.2-2.7
    C39.5,7,40.4,6.9,41.1,6.9z"
            />
            <path
                id="path177_1_"
                class="st44"
                d="M35.8,7.3c0.7-0.1,1.3,0.4,1.4,1.1v0.1c0,0.1,0,0.2,0,0.3c0,0.7-0.6,1.3-1.3,1.3l0,0
    c-0.8,0-1.5-0.6-1.6-1.4C34.4,7.9,34.6,7.3,35.8,7.3z M41.4,7.1C42.2,7,42.9,7.6,43,8.4c0,0.1,0,0.1,0,0.2c0,0.8-0.6,1.4-1.4,1.4
    l0,0l0,0c-0.9,0-1.3-0.9-1.4-1.4C40,8,40.4,7.4,41,7.2l0,0h0.1C41.1,7.1,41.2,7.1,41.4,7.1L41.4,7.1z"
            />
            <path
                id="path179_1_"
                class="st45"
                d="M36.2,7.7c0.4,0,0.4,0.3,0.4,0.4c0,0.2-0.2,0.4-0.4,0.4s-0.4-0.2-0.4-0.4l0,0
    C35.8,8,35.8,7.7,36.2,7.7z M41.9,7.6c0.2,0,0.4,0.1,0.4,0.3l0,0l0,0V8c0,0.1,0,0.4-0.4,0.4c-0.2,0-0.4-0.2-0.4-0.4l0,0
    C41.4,7.8,41.6,7.6,41.9,7.6L41.9,7.6z"
            />
            <ellipse id="ellipse181_1_" class="st25" cx="31.3" cy="26" rx="3.2" ry="5.9" />
            <ellipse id="ellipse183_1_" class="st26" cx="31.3" cy="26" rx="3.1" ry="5.7" />
            <ellipse id="ellipse185_1_" class="st27" cx="31.3" cy="26" rx="1.8" ry="3.3" />
            <ellipse id="ellipse187_1_" class="st33" cx="31.3" cy="26" rx="1.2" ry="2.3" />
            <path id="path189_1_" class="st46" d="M17,9.6c0,0-0.3,0.3-0.3,0.5c-0.2-0.1-1.4-0.5-1.4-0.5H17z" />
            <path
                id="path230_1_"
                class="st47"
                d="M47.3,18.6v-1.3h0.4v1H48v0.3H47.3z M48.1,18.1v-0.9h0.4v0.9c0,0.1,0.2,0.1,0.2,0v-0.9h0.4
    v0.9c-0.1,0.3-0.3,0.4-0.6,0.4l0,0C48.3,18.4,48.1,18.3,48.1,18.1z M49.1,18.5v-1.3h0.4v0.5l0.2-0.5h0.4l-0.3,0.6l0.3,0.7h-0.4
    L49.5,18v0.5H49.1z M50.3,18.4v-1.3H51v0.3h-0.3v0.2h0.2v0.3h-0.2v0.2H51v0.3H50.3z M52.1,18v-0.2H52V17h-0.3l-0.5,0.8V18h0.5v0.3
    H52L52.1,18z M51.7,17.3v0.5h-0.3L51.7,17.3z"
            />
            <path
                class="st34"
                d="M175.7,28.4v4.7h-8.8v-4.7h-11v-5.2l10.6-18.4h9.2v18.8h1.9v4.8C177.6,28.4,175.7,28.4,175.7,28.4z
        M167.1,13.1c-0.5,1.5-1.1,2.9-1.9,4.2l-3.5,6.2h5.4v-6.1C166.9,15.1,167.2,13.1,167.1,13.1L167.1,13.1z M66.1,29.2V8.9h3.8v17.8
    h5.6v2.5C75.5,29.2,66.1,29.2,66.1,29.2z"
            />
            <path
                class="st34"
                d="M81.7,29.5c-5.5,0-7.6-4.7-7.6-10.4s2.2-10.4,7.6-10.4s7.6,4.7,7.6,10.4S87.1,29.5,81.7,29.5z M81.7,11.1
    c-3.1,0-3.8,4-3.8,7.8s0.6,7.8,3.8,7.8c3.2,0,3.8-4,3.8-7.8S84.8,11.1,81.7,11.1z M97.3,29.5c-5.5,0-7.6-4.7-7.6-10.4
    s2.2-10.4,7.6-10.4s7.6,4.7,7.6,10.4S102.8,29.5,97.3,29.5L97.3,29.5z M97.3,11.1c-3.1,0-3.8,4-3.8,7.8s0.6,7.8,3.8,7.8
    s3.8-4,3.8-7.8S100.5,11.1,97.3,11.1L97.3,11.1z M115.6,29.2l-5.8-10.3h-0.1v10.3H106V8.9h3.7v9.3h0.1l5.8-9.3h3.8l-6.3,9.4
    l6.7,10.9C119.8,29.2,115.6,29.2,115.6,29.2z M119.8,29.2V8.9h3.8v20.3C123.6,29.2,119.8,29.2,119.8,29.2z M136.5,29.2l-7.7-13.1
    c-0.5-0.7-0.9-1.5-1.2-2.3h-0.1c0,0,0.1,1.1,0.1,2.4v13h-3.2V8.9h3.5l7.3,12.3c0.4,0.7,0.8,1.4,1.1,2.1h0.1c0,0-0.1-1-0.1-2.2V8.9
    h3.1v20.3C139.4,29.2,136.5,29.2,136.5,29.2z M148.8,29.5c-5.4,0-8.8-3.7-8.8-10.6c0-6.5,3.7-10.3,8.9-10.3
    c1.8-0.1,3.5,0.3,5.1,1.1l-1.1,2.3c-1.1-0.6-2.3-0.9-3.5-0.8c-3.5,0-5.6,2.4-5.6,7.8c0,5.1,2.1,7.8,4.9,7.8c0.7,0.1,1.4-0.1,2-0.4
    v-6.8h-2.9v-2.3h6.5v11C152.7,29.2,150.8,29.6,148.8,29.5L148.8,29.5z M182.7,20.5l-1-0.1v8.8H180V9.6c1.4-0.8,3-1.1,4.5-1.1
    c4.4,0,6.5,2.4,6.5,6S188.7,21,182.7,20.5L182.7,20.5z M184.5,9.6c-0.9,0-1.8,0.2-2.7,0.5v9.1l1,0.1c4.9,0.4,6.7-1.7,6.7-4.9
    S187.9,9.6,184.5,9.6L184.5,9.6z M203.8,29.2l-2.2-6.9h-7.4l-2.3,6.9h-1.6l7-20.3h1.3l7,20.3H203.8z M198.6,12.9
    c-0.3-0.8-0.5-1.7-0.6-2.5h-0.1c-0.1,0.8-0.4,1.6-0.7,2.4l-2.7,8.2h6.7L198.6,12.9z M216.8,29.2l-7.6-9.7h-0.1v9.7h-1.6V9.6
    c1.4-0.7,2.9-1.1,4.5-1.1c4.2,0,6.4,2.2,6.4,5.9s-2.6,5.9-6.9,5.7v0.1l7.3,8.9h-2V29.2z M211.9,9.6c-1,0-1.9,0.1-2.8,0.5v9
    c0.7,0.1,1.4,0.2,2.1,0.2c3.7,0,5.5-1.7,5.5-4.9S215.2,9.6,211.9,9.6L211.9,9.6z M230.2,29.2l-7.4-10.7h-0.1v10.7h-1.5V8.9h1.6v9.5
    h0.1l7.3-9.5h1.8l-7.5,9.5l7.8,10.8H230.2z M234.1,29.2V8.9h1.7v20.3C235.8,29.2,234.1,29.2,234.1,29.2z M251.7,29.2l-9.6-16.5
    c-0.8-1.4-1.4-2.7-1.4-2.7h-0.1c0,0,0.1,1.3,0.1,2.7v16.4h-1.4V8.8h2.2l9.3,16.2c0.5,0.7,0.9,1.5,1.2,2.3h0.1c0,0-0.1-1-0.1-2.4
    V8.8h1.4v20.3L251.7,29.2L251.7,29.2z M264.3,29.5c-4,0-8.2-3.1-8.2-10.6c0-7.1,4.1-10.3,8.1-10.3c1.5-0.1,3.1,0.2,4.4,1l-0.4,1
    c-1.2-0.6-2.5-0.9-3.8-0.9c-4,0-6.5,3-6.5,9.4c0,5.9,2.9,9.2,6.5,9.2c1.1,0.1,2.1-0.1,3.1-0.6v-8.5h-4v-1.1h5.6v10.3
    C267.7,29.2,266,29.6,264.3,29.5L264.3,29.5z"
            />
        </g>
    </svg>
</template>

<style lang="postcss" scoped>
svg {
    .st0 {
        display: none;
        fill: #eae9e9;
    }
    .st1 {
        display: none;
        fill: #948f8f;
    }
    .st2 {
        display: none;
        fill: #bfbcbc;
    }
    .st3 {
        display: none;
        fill: #1e1e1f;
    }
    .st4 {
        display: none;
        fill: #383838;
    }
    .st5 {
        display: none;
        fill: #626365;
    }
    .st6 {
        display: none;
        fill: #93828a;
    }
    .st7 {
        display: none;
        fill: #ee7b1a;
    }
    .st8 {
        display: none;
        fill: #98999e;
    }
    .st9 {
        display: none;
        fill: #3e3283;
    }
    .st10 {
        display: none;
        fill: #616264;
    }
    .st11 {
        display: none;
        fill: #77777a;
    }
    .st12 {
        display: none;
        fill: #504992;
    }
    .st13 {
        display: none;
        fill: #e1e3e8;
    }
    .st14 {
        display: none;
        fill: #8c88ab;
    }
    .st15 {
        display: none;
        fill: #61571a;
    }
    .st16 {
        display: none;
        fill: #ffd803;
    }
    .st17 {
        display: none;
        fill: #726aac;
    }
    .st18 {
        display: none;
        fill: #f9da5f;
    }
    .st19 {
        display: none;
        fill: #8b9da7;
    }
    .st20 {
        display: none;
        fill: #cdd1dc;
    }
    .st21 {
        display: none;
        fill: #063c2f;
    }
    .st22 {
        display: none;
        fill: #d8e4e0;
    }
    .st23 {
        display: none;
        fill: #574d0f;
    }
    .st24 {
        display: none;
        fill: #6b3084;
    }
    .st25 {
        fill: #1f1e1f;
    }
    .st26 {
        fill: #383938;
    }
    .st27 {
        fill: #636466;
    }
    .st28 {
        fill: #93828a;
    }
    .st29 {
        fill: #ec7b23;
    }
    .st30 {
        fill: #98999e;
    }
    .st31 {
        fill: #562f68;
    }
    .st32 {
        fill: #626364;
    }
    .st33 {
        fill: #78787a;
    }
    .st34 {
        fill: #6c3184;
    }
    .st35 {
        fill: #e1e3e9;
    }
    .st36 {
        fill: #8d89ac;
    }
    .st37 {
        fill: #6f3586;
    }
    .st38 {
        fill: #625824;
    }
    .st39 {
        fill: #fdd800;
    }
    .st40 {
        fill: #88499d;
    }
    .st41 {
        fill: #f9da60;
    }
    .st42 {
        fill: #8b9da7;
    }
    .st43 {
        fill: #ffffff;
    }
    .st44 {
        fill: #083c30;
    }
    .st45 {
        fill: #d8e4e0;
    }
    .st46 {
        fill: #874a9d;
    }
    .st47 {
        fill: #574e20;
    }
}
</style>
